export const EVENT_GROUPS = `
	query eventGroups($event_id: Uint, $search_term: String) {
		eventGroups(event_id: $event_id, search_term: $search_term) {
			id
			name
			event_id
			track
			attendees {
				page_info {
					total_count
				}
			}
		}
	}
`;

export const GROUP = `
	query group($id: Uint) {
		group(id: $id) {
			id
			name
			event_id
			track
			attendees {
				nodes {
					id
					email
					first_name
					last_name
				}
				page_info {
					has_next_page
					total_count
				}
			}
		}
	}
`;

export const GROUP_AGENDA = `
	query groupAgenda($event_id: Uint, $group_id: Uint) {
		groupAgenda(event_id: $event_id, group_id: $group_id) {
			id
			name
			description
			location
			link
			notes
			agenda_color
			start_time
			end_time
			recurring
			recurring_type
			groups {
				id
				name
			}
			materials {
				id
				name
				link
				groups {
					id
					name
				}
			}
		}
	}
`;
